import { LegalContentPage } from "@/components/LegalContentPage";

export default function PoliticaDePrivacidade() {
  return (
    <LegalContentPage
      overline="Legal"
      title="Política de privacidade"
      subtitle="Sua privacidade é importante para nós. Saiba como a Miríade Turismo trata os seus dados."
      seoTitle="Política de Privacidade | Miríade Turismo"
      seoDescription="Entenda como a Miríade Turismo coleta, utiliza e protege os seus dados pessoais, em linha com a LGPD."
      updated="Junho de 2026"
      intro="Esta Política de Privacidade explica, de forma simples e transparente, como a Miríade Turismo coleta, utiliza e protege as informações dos usuários, em linha com a Lei Geral de Proteção de Dados (LGPD)."
      sections={[
        {
          heading: "1. Quais dados coletamos",
          paragraphs: ["Podemos coletar informações fornecidas por você ao entrar em contato ou solicitar atendimento, como nome, telefone, e-mail e detalhes relacionados à viagem desejada."],
        },
        {
          heading: "2. Como usamos os dados",
          paragraphs: ["Utilizamos as informações para responder às suas solicitações, oferecer atendimento, orientar a escolha de viagens e melhorar a sua experiência conosco."],
          list: [
            "Responder a contatos e solicitações de atendimento.",
            "Auxiliar na busca e na escolha de viagens.",
            "Aprimorar nossos serviços e a comunicação com você.",
          ],
        },
        {
          heading: "3. Compartilhamento de dados",
          paragraphs: ["Não vendemos seus dados. O compartilhamento ocorre apenas quando necessário para viabilizar o atendimento e a realização da viagem, sempre com responsabilidade e dentro da finalidade informada."],
        },
        {
          heading: "4. Armazenamento e segurança",
          paragraphs: ["Adotamos medidas para proteger as suas informações contra acessos não autorizados. Mantemos os dados apenas pelo tempo necessário para cumprir as finalidades descritas ou exigências legais."],
        },
        {
          heading: "5. Seus direitos",
          paragraphs: ["Você pode solicitar informações sobre os seus dados, bem como a correção ou a exclusão deles, conforme previsto na legislação. Para isso, basta entrar em contato com a nossa equipe."],
        },
        {
          heading: "6. Cookies",
          paragraphs: ["Este site pode utilizar cookies e tecnologias semelhantes para melhorar a navegação e a sua experiência. Você pode gerenciar as preferências de cookies nas configurações do seu navegador."],
        },
        {
          heading: "7. Contato",
          paragraphs: ["Em caso de dúvidas sobre esta política ou sobre o tratamento dos seus dados, fale com a Miríade Turismo pelos canais oficiais divulgados neste site."],
        },
      ]}
      ctaTitle="Tem dúvidas sobre privacidade?"
      ctaText="Fale com a Miríade e esclareça suas dúvidas sobre o tratamento dos seus dados."
    />
  );
}
